"use client";

import { useEffect, useRef } from "react";
import { usePostHog } from "@/lib/analytics/posthog-react";
import { captureEvent, POSTHOG_EVENTS } from "@/lib/analytics/posthog";

interface TrackEventOnMountProps {
  event: (typeof POSTHOG_EVENTS)[keyof typeof POSTHOG_EVENTS];
  properties?: Record<string, string | number | boolean | null | undefined>;
}

export function TrackEventOnMount({ event, properties }: TrackEventOnMountProps) {
  const posthog = usePostHog();
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current) {
      return;
    }

    hasTrackedRef.current = true;
    captureEvent(posthog, event, properties);
  }, [event, posthog, properties]);

  return null;
}
